<template>
	<v-col class="purchase-product">
		<ModalDetailProduk :product="selectedProduct" ref="modalDetail"></ModalDetailProduk>
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">Stock Produk</div>
		</div>
		<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
			<v-icon small color="grey">mdi-storefront</v-icon>
			<div class="pl-2">Stockist Area</div>
			<div class="px-2">/</div>
			<div>Stock Produk</div>
		</div>
		<div class="mt-5">
			<v-row class="ml-0 body-transaction-product">
				<v-col cols="12" sm="12" md="3" xl="2" class="pl-0 pt-0 col-md-20" v-for="product in listProductAll" :key="product.product_id">
					<v-card class="pa-3 elevation-0 rounded-lg hover-shadow" :disabled="(product.product_qty === 0) ? true : false">
						<a href="javascript:void(0)" title="Klik untuk melihat detail Produk" @click="showDetailProduct(product)">
							<v-img contain height="165px" class="rounded-lg" :src="(product.product_image) ? product.product_image : '/assets/image/user-pict.jpg'"></v-img>
						</a>
						<div class="pt-3">
							<div class="font-size-11 product-name font-weight-bold">{{ product.product_name }}</div>
							<div class="font-size-10 cl-secondary">Stok : <b :class="{'red--text': product.product_qty === 0}" >{{ (product.product_qty > 0) ? product.product_qty : 'HABIS' }}</b></div>
							<div class="font-size-10 cl-primary">{{ product.product_member_price | toRupiah }}</div>
						</div>
					</v-card>
				</v-col>
			</v-row>
		</div>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ModalDetailProduk from './components/ModalDetailProduk';

export default {
	components: { ModalDetailProduk },
	data() {
		return {
			selectedProduct: null
		}
	},
	computed: {
		...mapState('auth', ['userData']),
		...mapState('product', ['listProductAll']),
	},
	methods: {
		...mapActions('product', ['getProductAll']),

		getData() {
			this.getProductAll()
		},

		showDetailProduct(product) {
			this.selectedProduct = product
			this.$refs.modalDetail.modalShow()
		},
	},
	created(){
		this.$store.dispatch('setPageTitle', `Data Produk`)
		this.getData()
	},
};
</script>
